import React, { Component } from 'react'
import LoopSliderBox from '../../ReusableComponents/NewSlider/LoopSliderBox'

import './loop.css'

class LoopPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        const { state } = this.props
        return (
            <div
                style={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <LoopSliderBox
                    style={{ width: '80%' }}
                    min={0}
                    max={255}
                    value={state.times || 1}
                    onChange={(e) => {
                        this.props.onChange({ times: e.target.value })
                    }}
                />
            </div>
        )
    }
}

export default LoopPanel
